module.exports = __webpack_public_path__ + "static/img/blog-2-21.72e4e0ab.png";